export const permissionsTranslations = {
  ar: {
    title: 'الصلاحيات',
    users: 'المستخدمين',
    roles: 'الأدوار',
    search: 'بحث',
    menus: 'القوائم',
    selectUser: 'اختر المستخدم',
    selectRole: 'اختر الدور',
    selectRoleFirst: 'يرجى اختيار الدور أولاً',
    grantPermissionsConfirm: 'هل أنت متأكد من منح جميع الصلاحيات لهذا الدور؟',
    grantAllPermissions: 'منح جميع الصلاحيات',
    addNew: 'إضافة جديد',
    permissionLevel: 'مستوى الصلاحية',
    edit: 'تعديل',
    delete: 'حذف',
    selectMenu: 'اختر القائمة',
    cancel: 'إلغاء',
    save: 'حفظ',
    noPermission: 'لا توجد صلاحية',
    readOnly: 'قراءة فقط',
    readWrite: 'قراءة/كتابة',
    fullAccess: 'وصول كامل',
  },
  en: {
    title: 'Permissions',
    users: 'Users',
    roles: 'Roles',
    search: 'Search',
    menus: 'Menus',
    selectUser: 'Select User',
    selectRole: 'Select Role',
    selectRoleFirst: 'Please select a role first',
    grantPermissionsConfirm: 'Are you sure you want to grant all permissions to this role?',
    grantAllPermissions: 'Grant All Permissions',
    addNew: 'Add New',
    permissionLevel: 'Permission Level',
    edit: 'Edit',
    delete: 'Delete',
    selectMenu: 'Select Menu',
    cancel: 'Cancel',
    save: 'Save',
    noPermission: 'No Permission',
    readOnly: 'Read Only',
    readWrite: 'Read/Write',
    fullAccess: 'Full Access',
  },
  fr: {
    title: 'Autorisations',
    users: 'Utilisateurs',
    roles: 'Rôles',
    search: 'Rechercher',
    menus: 'Menus',
    selectUser: 'Sélectionner l\'utilisateur',
    selectRole: 'Sélectionner le rôle',
    selectRoleFirst: 'Veuillez d\'abord sélectionner un rôle',
    grantPermissionsConfirm: 'Êtes-vous sûr de vouloir accorder toutes les autorisations à ce rôle?',
    grantAllPermissions: 'Accorder toutes les autorisations',
    addNew: 'Ajouter nouveau',
    permissionLevel: 'Niveau d\'autorisation',
    edit: 'Modifier',
    delete: 'Supprimer',
    selectMenu: 'Sélectionner le menu',
    cancel: 'Annuler',
    save: 'Enregistrer',
    noPermission: 'Aucune autorisation',
    readOnly: 'Lecture seule',
    readWrite: 'Lecture/Écriture',
    fullAccess: 'Accès complet',
  },
}

